import { useState } from 'react';
import { entries, heroStats } from '@/mocks/home';

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) {
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 96, behavior: 'smooth' });
  }
}

export default function Hero() {
  const [copied, setCopied] = useState(false);
  const primary = entries[0];

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(primary.domain);
    } catch {
      /* 复制失败时仍给出反馈，不中断浏览 */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20magazine%20background%20with%20warm%20amber%20and%20deep%20crimson%20light%20leaks%2C%20dramatic%20cinematic%20vignette%2C%20soft%20film%20grain%20texture%2C%20moody%20atmospheric%20smoke%20haze%2C%20blurred%20bokeh%20highlights%2C%20no%20text%2C%20refined%20artistic%20poster%20design&width=1600&height=900&seq=hl-hero-bg-01&orientation=landscape"
          alt="51黑料最新地址入口背景"
          title="51黑料最新地址 官网入口"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/75 to-foreground-950/90" />

      <div className="relative mx-auto max-w-shell px-4 pb-12 pt-32 md:px-6 md:pb-16 md:pt-40">
        <div className="hl-rise max-w-3xl">
          <div className="mb-5 flex flex-wrap items-center gap-2">
            <span className="rounded-full bg-accent-500 px-3 py-1 font-label text-[13px] tracking-wider text-background-50">
              地址索引
            </span>
            <span className="rounded-full border border-background-50/30 px-3 py-1 text-[13px] text-background-100">
              2026-10-10 更新
            </span>
            <span className="rounded-full border border-background-50/30 px-3 py-1 text-[13px] text-background-100">
              全网入口巡检中
            </span>
          </div>
          <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            51黑料最新地址
            <span className="mt-2 block text-primary-300">官网入口 · 备用域名 · 打不开的找法</span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            整理 51黑料官网最新地址与全部备用域名。当网址打不开或入口失效时，这里能让你一眼看到当前可访问的最新入口，
            并按状态标记挑选更稳定的线路，随时访问不迷路。
          </p>
        </div>

        <div className="hl-rise mt-8 overflow-hidden rounded-lg border border-background-50/20 bg-foreground-950/60 backdrop-blur">
          <div className="flex items-center gap-2 border-b border-background-50/15 px-4 py-2.5 md:px-5">
            <span className="hl-live-dot h-2 w-2 rounded-full bg-primary-400" />
            <span className="font-label text-sm tracking-wider text-background-100">当前推荐入口</span>
            <span className="ml-auto text-[12px] text-background-200">{primary.load}</span>
          </div>
          <div className="flex flex-col gap-3 px-4 py-4 md:flex-row md:items-center md:px-5">
            <div className="flex flex-1 items-center gap-3">
              <i className="ri-links-line text-2xl text-primary-300" />
              <div className="min-w-0">
                <p className="font-heading text-lg text-background-50 md:text-xl">{primary.domain}</p>
                <p className="truncate text-[12px] text-background-200">{primary.note}</p>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={handleCopy}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className={copied ? 'ri-check-line text-primary-300' : 'ri-file-copy-line'} />
                {copied ? '已复制' : '复制域名'}
              </button>
              <button
                type="button"
                onClick={() => scrollToId('entry')}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-600"
              >
                全部入口合集
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-3 gap-3 md:gap-4">
          {heroStats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-50/15 bg-background-50/5 px-3 py-3 md:px-4 md:py-4">
              <p className="font-label text-2xl text-primary-300 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-[12px] text-background-200">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}